/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Danger_Token_MismatchInputs */



/**
* | output |
* | --- |
* | "That token is for a different bot than this server's." |
*
* @param {Tenant_Danger_Token_MismatchInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const tenant_danger_token_mismatch = /** @type {((inputs?: Tenant_Danger_Token_MismatchInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Danger_Token_MismatchInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот токен от другого бота, а не от бота этого сервера.")
	return /** @type {LocalizedString} */ ("That token is for a different bot than this server's.")
});